import { Component, OnInit } from '@angular/core';
import { SchoolService } from '../school.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.scss'],
})
export class SchoolComponent implements OnInit {
  courses: any = [];
  jounerData = { name: '', Description: '', CardIconURL: '' };
  nums: string = '';
  ngOnInit(): void {
    console.log('ss');
    this.global.getJourney().subscribe((res) => {
      this.courses = res.Object;
      console.log(res);
    });
  }

  closeResult = '';
  constructor(private global: SchoolService, private modalService: NgbModal,
    private translate : TranslateService) {}

  open(content: any, id: number, num: string = '') {
    console.log(id);
    this.global.getJourneyData(id).subscribe((res: any) => {
      console.log(res);
      this.jounerData.Description = res.Object.Description.replace('<p>', '');
      this.jounerData.Description = this.jounerData.Description.replace(
        '</p>',
        ''
      );
      this.jounerData.name = res.Object.name;

      this.jounerData.CardIconURL = res.Object.CardIconURL;
      this.nums = num;
    });

    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
}
